import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('onlendings', storeModule.createStoreModule('onlendings'))
